// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6136cca","239":"b39aca96","453":"807087f8","455":"bc87079c"}[chunkId] + ".chunk.js";
};